export default __webpack_public_path__ + "static/media/still2.92ff9294.jpg";